// extracted by mini-css-extract-plugin
var _1 = "CarouselThumbnailImage-module__animateUploadProgressBarWidth--_AhI7";
var _2 = "CarouselThumbnailImage-module__animatedBackground--rkR2_";
var _3 = "CarouselThumbnailImage-module__container--ZWJUa";
var _4 = "CarouselThumbnailImage-module__isSelected--Fy71f";
var _5 = "CarouselThumbnailImage-module__placeholder--namNc";
var _6 = "CarouselThumbnailImage-module__thumbnail--aroWQ";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "isSelected", _5 as "placeholder", _6 as "thumbnail" }
